import { createFileRoute } from "@tanstack/react-router";
import { CrewDetailPage } from "~/pages/crew/CrewDetailPage";
export const Route = createFileRoute("/_authenticated/crew/$memberId")({ component: CrewDetailPage });
